export default "__VITE_ASSET__1ry7yJOq__"